var React = require('react');

function HomeMobileActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 8.8L10.75 0.25L21.5 8.8V23.05H13.25V16.55H8.25V23.05H0L0 8.8Z","fill":"white"}));
}

HomeMobileActive.defaultProps = {"width":"22","height":"24","viewBox":"0 0 22 24","fill":"none"};

module.exports = HomeMobileActive;

HomeMobileActive.default = HomeMobileActive;
